import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format a listing price for display. Always renders "S$x,xxx,xxx" for plain
// numbers (incl. legacy listings stored as a bare number like "50000000"),
// while leaving already-formatted or descriptive prices ("S$2.5M",
// "Offers above S$2m", "Price on ask") untouched.
export function formatPrice(listing = {}) {
  const raw = listing.price;
  // Has any non-numeric character (currency/letters/etc.) → already display-ready.
  if (raw != null && String(raw).trim() !== "" && /[^\d\s.,]/.test(String(raw))) {
    return String(raw);
  }
  const digits = String(listing.priceValue ?? raw ?? "").replace(/[^\d]/g, "");
  const n = Number(digits);
  return n ? `S$${n.toLocaleString("en-US")}` : (raw ? String(raw) : "");
}

// Strip HTML tags to plain text — used for previews/snippets of rich-text
// (TipTap) content on cards and meta descriptions.
export function stripHtml(html = "") {
  if (!html) return "";
  if (!/<[a-z][\s\S]*>/i.test(html)) return html;
  if (typeof document !== "undefined") {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
  }
  return html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}
